import React from 'react';

export function EnergyIconAFF() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 91.15 52.45">
            <defs>
                <style>
                    {`
                        .cls-1-f {
                            stroke-width: .82px;
                        }

                        .cls-1-f, .cls-2-f, .cls-3-f {
                            stroke: #231f20;
                            stroke-linecap: round;
                            stroke-linejoin: round;
                        }

                        .cls-1-f, .cls-3-f {
                            fill: none;
                        }

                        .cls-4-f {
                            font-size: 18.42px;
                        }

                        .cls-4-f, .cls-5-f {
                            fill: #231f20;
                            font-family: Calibri-Bold, Calibri;
                            font-weight: 700;
                        }

                        .cls-6-f {
                            fill: #ed1c24;
                        }

                        .cls-6-f, .cls-7-f {
                            stroke-width: 0px;
                        }

                        .cls-5-f {
                            font-size: 10px;
                        }

                        .cls-2-f {
                            stroke-width: .5px;
                        }

                        .cls-2-f, .cls-7-f {
                            fill: #fff;
                        }

                        .cls-3-f {
                            stroke-width: 1.07px;
                        }
                    `}
                </style>
            </defs>
            <g id="F">
                <rect className="cls-7-f" x="69.5" y=".73" width="21.33" height="49" />
                <polygon className="cls-6-f" points="22.62 .77 .29 25.06 22.62 49.35 71.62 49.35 71.62 .77 22.62 .77" />
                <path
                    className="cls-1-f"
                    d="M23.1.41h67.27c.2,0,.36.16.36.36v48.58c0,.2-.16.36-.36.36H23.1c-.1,0-.2-.04-.26-.12L.5,25.3c-.13-.14-.13-.35,0-.48L22.84.52c.07-.07.16-.12.26-.12Z"
                />
                <path
                    className="cls-2-f"
                    d="M49.9,15.95c0,.37-.01.68-.04.94-.03.25-.07.46-.14.6-.06.15-.13.26-.21.33-.08.07-.17.11-.27.11h-7.26v6.46h6.81c.1,0,.19.03.27.09s.15.17.21.32c.06.15.11.35.14.59.03.25.04.56.04.93s-.01.68-.04.93c-.03.25-.07.45-.14.61-.06.16-.13.28-.21.34-.08.07-.17.1-.27.1h-6.81v8.95c0,.14-.03.25-.1.35-.07.1-.19.18-.37.25-.18.07-.41.12-.7.16-.29.04-.65.06-1.1.06s-.8-.02-1.09-.06c-.29-.04-.52-.09-.7-.16-.17-.07-.29-.15-.37-.25-.07-.1-.11-.22-.11-.35V15.49c0-.54.13-.94.39-1.18s.57-.36.95-.36h10.45c.1,0,.19.03.27.1s.15.18.21.33c.06.15.11.36.14.62.03.26.04.58.04.95Z"
                />
            </g>
            <g id="Layer_11" data-name="Layer 11">
                <g>
                    <line className="cls-3-f" x1="81.33" y1="30.37" x2="81.33" y2="20.01" />
                    <polyline className="cls-3-f" points="84.08 22.71 81.33 19.96 78.59 22.71" />
                </g>
                <text className="cls-4-f" transform="translate(76.62 45.94) scale(1 1.01)">
                    <tspan x="0" y="0">
                        F
                    </tspan>
                </text>
                <text className="cls-4-f" transform="translate(74.84 15.94) scale(1 1.01)">
                    <tspan x="0" y="0">
                        A
                    </tspan>
                </text>
                <text className="cls-5-f" transform="translate(83.5 9.24) scale(1 1.01)">
                    <tspan x="0" y="0">
                        +
                    </tspan>
                </text>
            </g>
        </svg>
    );
}
